import { useEffect, useState } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { publicApi } from '@/lib/api';
import { useLanguage } from '@/lib/i18n';

export default function Legal() {
  const [settings, setSettings] = useState({});
  const { t } = useLanguage();

  useEffect(() => {
    publicApi.getSettings().then(r => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-cream" data-testid="legal-page">
      <Navbar />
      <div className="pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-heading font-bold text-garden-800 mb-8">{t('legal.title')}</h1>

          <div className="bg-white rounded-2xl p-8 border border-garden-800/5 shadow-sm space-y-8">
            <section>
              <h2 className="text-xl font-heading font-semibold text-garden-800 mb-3">{t('legal.editor')}</h2>
              <p className="text-sm text-charcoal/80 leading-relaxed">
                {settings.legal_editor || 'Cote Terrasse SARL'}<br />
                {settings.address || '198 Cours de l\'Argonne, 33000 Bordeaux, France'}<br />
                {t('legal.phone')} : {settings.phone || '09 52 67 52 89'}<br />
                {t('legal.publishedBy')} : {settings.legal_responsible || 'Le gerant du restaurant'}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-semibold text-garden-800 mb-3">{t('legal.hosting')}</h2>
              <p className="text-sm text-charcoal/80 leading-relaxed">
                {settings.legal_host || 'Gandi SAS'}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-semibold text-garden-800 mb-3">{t('legal.ip')}</h2>
              <p className="text-sm text-charcoal/80 leading-relaxed">{t('legal.ipText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-semibold text-garden-800 mb-3">{t('legal.data')}</h2>
              <p className="text-sm text-charcoal/80 leading-relaxed">{t('legal.dataText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-semibold text-garden-800 mb-3">{t('legal.cookies')}</h2>
              <p className="text-sm text-charcoal/80 leading-relaxed">{t('legal.cookiesText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-semibold text-garden-800 mb-3">{t('legal.privacy')}</h2>
              <p className="text-sm text-charcoal/80 leading-relaxed">{t('legal.privacyText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-heading font-semibold text-garden-800 mb-3">{t('legal.responsibility')}</h2>
              <p className="text-sm text-charcoal/80 leading-relaxed">{t('legal.responsibilityText')}</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
